import { Component, computed, inject, input } from '@angular/core';
import { OnyxTheme } from '../../../enums';
import { OnyxThemeService } from '../../../services/onyx-theme.service';
import { OnyxSpinnerComponent } from '../../spinner/onyx-spinner/onyx-spinner.component';

@Component({
  selector: 'onyx-loading-banner',
  imports: [OnyxSpinnerComponent],
  templateUrl: './onyx-loading-banner.component.html',
  styleUrl: './onyx-loading-banner.component.scss',
})
export class OnyxLoadingBannerComponent {
  private readonly themeService = inject(OnyxThemeService);

  public readonly delay = input(true);
  public readonly visible = input.required<boolean>();

  protected isInverse = computed(
    () => this.themeService.theme() === OnyxTheme.LIGHT,
  );
}
